import type { MouseEventHandler } from 'react'
import { useCallback, useContext } from 'react'
import { FormattedMessage } from 'react-intl'
import LoyaltyTierMessageBanner from '../LoyaltyTierMessageBanner'
import TextLink from 'LuxKit/TextLink'
import ModalContext from 'contexts/ModalContext'
import TierProgressionInfoModal from './TierProgressionInfoModal'

interface Props {
  highestUnlockableTier: App.LoyaltyTier
  highestUnlockableTierName: string
  className?: string
  onBookNow?: () => void
  onAddToCart?: () => void
  checkoutDate?: string
}

function LoyaltyTierProgressionBanner({
  highestUnlockableTier,
  highestUnlockableTierName,
  className,
  onBookNow,
  onAddToCart,
  checkoutDate,
}: Props) {
  const showModal = useContext(ModalContext)

  const handleOpenModal = useCallback<MouseEventHandler>((event) => {
    event.preventDefault()
    showModal(<TierProgressionInfoModal
      tiers={[highestUnlockableTier]}
      onBookNow={onBookNow}
      onAddToCart={onAddToCart}
      checkoutDate={checkoutDate}
    />)
  }, [showModal, highestUnlockableTier, onBookNow, onAddToCart, checkoutDate])

  return (
    <LoyaltyTierMessageBanner
      tier={highestUnlockableTier}
      className={className}
      endContent={
        <TextLink size="medium" onClick={handleOpenModal}>
          <FormattedMessage
            id="47I-Dg-m-UnGF5JPVVdV"
            defaultMessage="Learn more"
            description="Link to open tier progression info modal on per-package banner"
          />
        </TextLink>
      }
    >
      <FormattedMessage
        id="YmHifWkKXbDaNf5SAxmL"
        defaultMessage="Unlock {tierName} Status when you book this package"
        description="Message shown on per-package banner indicating tier unlock"
        values={{ tierName: highestUnlockableTierName }}
      />
    </LoyaltyTierMessageBanner>
  )
}

export default LoyaltyTierProgressionBanner
